import React from "react";
import EditorShell from "../EditorShell";
import StringListEditor from "../StringListEditor";
import { stepLabelsSchema, SECTION_DEFAULTS } from "../schemas";

const StepLabelsEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="step_labels"
    schema={stepLabelsSchema}
    defaults={SECTION_DEFAULTS.step_labels}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <StringListEditor
        form={form}
        name="labels"
        label="Stepper labels"
        placeholder="Verify, Set up, Start using"
        max={8}
        hint="Render order matches input order. Three labels are typical."
      />
    )}
  </EditorShell>
);

export default StepLabelsEditor;
